/* =====================================================================
   Andrina Yvette - small mobile behaviours
   Added 29 Aug 2026. Deferred; nothing here is needed for first paint.
   ===================================================================== */
(function () {
  var MQ = window.matchMedia('(max-width: 767px)');

  /* 1. Footer link groups become accordions on a phone.
        The footer ran 1,165px - a screen and a half of links closing
        every page. Each column here is a heading block followed by a
        links block; a column with more than those two (the newsletter)
        is left alone. */
  function footerAccordions() {
    var footer = document.querySelector('.bwp-footer');
    if (!footer) return;
    var cols = footer.querySelectorAll('.content-block-column');
    Array.prototype.forEach.call(cols, function (col) {
      if (col.children.length !== 2) return;
      if (col.getAttribute('data-ay-accordion')) return;
      var head = col.children[0];
      var panel = col.children[1];
      var title = head.querySelector('.bwp-block-title');
      if (!title) return;

      col.setAttribute('data-ay-accordion', '1');
      col.classList.add('ay-accordion');
      head.classList.add('ay-accordion__head');
      panel.classList.add('ay-accordion__panel');
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-expanded', 'false');

      function toggle() {
        if (!MQ.matches) return;
        var open = col.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  /* 2. The homepage video embeds pulled their whole player up front. */
  function lazyVideos() {
    var frames = document.querySelectorAll('iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="vimeo"]');
    Array.prototype.forEach.call(frames, function (f) {
      if (!f.getAttribute('loading')) f.setAttribute('loading', 'lazy');
    });
  }

  /* 3. Some pages print their title twice - once in the banner and again
        as the first heading of the content, word for word (the FAQ page
        is the clearest case). The banner is the one that stays; the
        repeat below it is marked and hidden by CSS. Editing either one in
        the customiser turns this off by itself, because the two strings
        stop matching. */
  function dedupePageTitle() {
    var banner = document.querySelector('.wpbingo-breadcrumbs__title');
    var main = document.querySelector('.main-content');
    if (!banner || !main) return;

    var wanted = banner.textContent.trim().toLowerCase();
    if (!wanted) return;

    var headings = main.querySelectorAll('h1, h2, h3');
    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      if (h === banner) continue;
      if (h.closest('.wpbingo-breadcrumbs')) continue;   // never the banner itself
      if (h.textContent.trim().toLowerCase() === wanted) {
        h.classList.add('ay-duplicate-title');
      }
      break;                                             // only the first heading after the banner
    }
  }

  function init() {
    footerAccordions();
    lazyVideos();
    dedupePageTitle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
